import type {
  ActionFactory,
  Context,
  EditActionDefinition,
  EditActionsDictionary,
  HostEditActionDefinition,
  HostEditAction,
  ActionNames,
  HostActionContext,
} from '@wix/editor-platform-host-integration-apis';
import { Action, DashboardAction } from '@wix/component-protocol/schema';
import { initBuilderServices } from '../builderServices/init';
import { PlatformApiMethods } from '../../../types/platformApi';

type CustomizedNativeManifestAction = {
  [K in keyof Action]-?: K extends 'execution'
    ? Action[K]
    : NonNullable<Action[K]>;
};

type CustomizedDashboardManifestAction = {
  [K in keyof DashboardAction]-?: K extends 'execution'
    ? DashboardAction[K]
    : NonNullable<DashboardAction[K]>;
};

type CustomManifestAction = {
  [K in keyof Action]-?: K extends 'execution'
    ? NonNullable<Action[K]>
    : Action[K];
};

const isCustomManifestAction = (
  action: CustomManifestAction | Action,
): action is CustomManifestAction => {
  return 'execution' in action;
};

type ManifestServicesAPI = ReturnType<typeof initBuilderServices>['manifest'];

type PlatformContext = Context<ManifestServicesAPI, PlatformApiMethods>;

type ExtendedPlatformContext = PlatformContext & HostActionContext;

type ActionFactoryWithPlatformContext = ActionFactory<
  ExtendedPlatformContext,
  EditActionDefinition | HostEditActionDefinition
>;

type PlatformEditAction =
  | HostEditActionDefinition
  | ActionFactoryWithPlatformContext;

type EditAction = HostEditAction | PlatformEditAction;

type ContributedPlatformActionsDict = EditActionsDictionary<PlatformEditAction>;

type ContributedEditActionsDict = EditActionsDictionary<EditAction>;

export {
  CustomizedNativeManifestAction,
  CustomizedDashboardManifestAction,
  CustomManifestAction,
  ActionNames,
  EditActionsDictionary,
  PlatformEditAction,
  ManifestServicesAPI,
  PlatformContext,
  ExtendedPlatformContext,
  ActionFactoryWithPlatformContext,
  EditAction,
  ContributedPlatformActionsDict,
  ContributedEditActionsDict,
  isCustomManifestAction,
};
